export default __webpack_public_path__ + "static/0117-10e5675ec98560a9ad5510e9115b45bb.png";